import React from "react";
import { Formik } from "formik";
import { CustomFileUpload } from "../../../common/FormInputs";
import useLoader from "../../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import { navigate } from "@reach/router";
import { createExcelValidationSchema } from "../../../../helpers/validationSchema";
import { StyledForm, ButtonGroup, BackButton, SubmitButton } from "./styles";
import { getFileName } from "../../../../helpers/functions";
import { Card, FormGrid, Label, PageWrapper, Section } from "./SplitAndUpload";

const CreateExcel = () => {
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();

  const upload_templates = [
    {
      name: "docxFile",
      label: "Upload Docx",
      type: "upload",
      required: true,
      accept: ".docx",
      types: [
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ],
    },
  ];

  async function onFormSubmit(values, { resetForm }) {
    try {
      setLoader({ state: true, message: "Excel file..." });
      let formData = new FormData();
      formData.append("docxFile", values.docxFile);
      const response = await fetch(`https://mod.justact.co.in/create-excel`, {
        method: "POST",
        body: formData,
      });
      if (response.ok) {
        const data = await response.json();
        enqueueSnackbar("Excel file created successfully", {
          variant: "success",
        });
        const a = document.createElement("a");
        a.href = data?.excel_file;
        a.download = `${getFileName(data?.excel_file)}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        resetForm();
      }
    } catch (error) {
      enqueueSnackbar(error?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  return (
    <PageWrapper>
      <Card>
        <Formik
          initialValues={{
            docxFile: "",
          }}
          validationSchema={createExcelValidationSchema}
          enableReinitialize
          onSubmit={onFormSubmit}
          validateOnBlur
          validateOnChange
        >
          {({
            values,
            handleChange,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFieldError,
            resetForm,
          }) => (
            <StyledForm>
              <Section>
                <FormGrid>
                  {upload_templates.map((upload, index) => (
                    <div>
                      <Label>
                        {upload.label} <span className="required-star"> *</span>
                      </Label>
                      <CustomFileUpload
                        error={touched[upload.name] && errors[upload.name]}
                        setFile={(file) => setFieldValue(upload.name, file)}
                        style={{
                          width: "100%",
                          boxSizing: "border-box",
                        }}
                        accept={upload.accept}
                        file={{
                          name: values[upload.name]?.name,
                        }}
                      />
                    </div>
                  ))}
                </FormGrid>
              </Section>
              <ButtonGroup>
                <BackButton onClick={() => navigate("/dashboard/case-manager")}>
                  Back
                </BackButton>
                <SubmitButton onClick={handleSubmit}>Submit</SubmitButton>
              </ButtonGroup>
            </StyledForm>
          )}
        </Formik>
      </Card>
    </PageWrapper>
  );
};

export default CreateExcel;
